module.exports = __webpack_public_path__ + "static/media/rf6.6250b689.jpg";